import { getVimeoVideoBaseUrl } from 'helpers/api';

export const getVideoUrl = (videoId: string) =>
  `${getVimeoVideoBaseUrl()}${videoId}?autoplay=1`;
